<template>
  <span class="toggle">
    <span class="open-toggle" @click.prevent="onExpand">
      <icon name="chevron-down" v-if="expanded"></icon>
      <icon name="chevron-left" v-else-if="rtl"></icon>
      <icon name="chevron-right" v-else></icon>
    </span>
  </span>
</template>

<script>
  import mixins from '../mixins';

  export default {
    mixins: [mixins.LocaleIsRTLMixin],

    props: {
      expanded: Boolean,
      rtlOverride: {
        required: false,
      },
    },
    computed: {
      rtl() {
        return this.rtlOverride === undefined ? this.locale_is_rtl : this.rtlOverride;
      },
    },
    methods: {
      onExpand() {
        this.$emit('expand');
      },
    },
  };
</script>
